import type { AssetExporter } from '@/shared/types/assets'

/**
 * 资产导出器注册表。
 * 与 LoaderRegistry 对称，按 format 管理导出器。
 */
export class ExporterRegistry<THandle, TOutput = Blob> {
  private exporters = new Map<string, AssetExporter<THandle, TOutput>>()

  /**
   * 注册导出器。
   *
   * @param exporter - 待注册导出器，format 不得为空且唯一
   * @throws format 为空或已注册时抛 Error
   */
  register(exporter: AssetExporter<THandle, TOutput>): void {
    const format = exporter.format?.trim()
    if (!format) {
      throw new Error('ExporterRegistry: format 不能为空')
    }
    if (this.exporters.has(format)) {
      throw new Error(`ExporterRegistry: format "${format}" 已注册`)
    }
    this.exporters.set(format, exporter)
  }

  /**
   * 按 format 精确查找导出器。
   *
   * @param format - 目标格式标识，自动忽略首尾空白
   * @returns 对应导出器，未注册返回 undefined
   */
  get(format: string): AssetExporter<THandle, TOutput> | undefined {
    return this.exporters.get(format.trim())
  }

  /**
   * 返回所有已注册的 format 列表。
   *
   * @returns 格式字符串数组，顺序与注册顺序一致
   */
  formats(): string[] {
    return Array.from(this.exporters.keys())
  }
}
